
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/live-player/[client]/[id]",
      function () {
        return require("private-next-pages/live-player/[client]/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/live-player/[client]/[id]"])
      });
    }
  